import type { Dispatch, SetStateAction } from 'react'

import type {
  FollowingUsersFilters as FollowingUsersFiltersType,
  GetUsersListFilters,
} from '@/modules/chatting/types'

import type { CollectionsItem } from '../../CollectionsList/types'
import { FansFilters } from './FansFilters'
import { FollowingUsersFilters } from './FollowingUsersFilters'

interface Props {
  list: CollectionsItem
  filters: GetUsersListFilters | FollowingUsersFiltersType
  setFilters: (filters: GetUsersListFilters | FollowingUsersFiltersType) => void
}

export const CollectionUsersFilters = ({
  list,
  filters,
  setFilters,
}: Props) => {
  if (list.type === 'custom') return null

  if (list.id.startsWith('fans')) {
    return (
      <FansFilters
        filters={filters as GetUsersListFilters}
        setFilters={setFilters as Dispatch<SetStateAction<GetUsersListFilters>>}
      />
    )
  }

  if (list.id.startsWith('following')) {
    return (
      <FollowingUsersFilters
        filters={filters as FollowingUsersFiltersType}
        setFilters={
          setFilters as Dispatch<SetStateAction<FollowingUsersFiltersType>>
        }
      />
    )
  }

  return null
}
